export const materia2URLs = {
  DEV: {
    reservations: 'https://staging.materia2.kabinhotel.xyz/reservations',
    tasks: 'https://staging.materia2.kabinhotel.xyz/tasks',
    chat: 'https://staging.materia2.kabinhotel.xyz/chat',
    doorLocks: 'https://staging.materia2.kabinhotel.xyz/door-locks',
  },
  STAGING: {
    reservations: 'https://staging.materia2.kabinhotel.xyz/reservations',
    tasks: 'https://staging.materia2.kabinhotel.xyz/tasks',
    chat: 'https://staging.materia2.kabinhotel.xyz/chat',
    doorLocks: 'https://staging.materia2.kabinhotel.xyz/door-locks',
  },
  QA: {
    reservations: 'https://qa.materia2.kabinhotel.xyz/reservations',
    tasks: 'https://qa.materia2.kabinhotel.xyz/tasks',
    chat: 'https://qa.materia2.kabinhotel.xyz/chat',
    doorLocks: 'https://qa.materia2.kabinhotel.xyz/door-locks',
  },
  PROD: {
    reservations: 'https://materia2.kabinhotel.xyz/reservations',
    tasks: 'https://materia2.kabinhotel.xyz/tasks',
    chat: 'https://materia2.kabinhotel.xyz/chat',
    doorLocks: 'https://materia2.kabinhotel.xyz/door-locks',
  },
};
